import * as types from './types';

export function init(config) {
  return {
    type: types.INIT,
    payload: config,
  };
}

export function ready() {
  return {
    type: types.READY,
  };
}

export function reset() {
  return {
    type: types.RESET,
  };
}
